import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './Portfolio.css';
import productImage1 from '../images/a1.webp';
import productImage2 from '../images/a2.webp';
import productImage3 from '../images/a3.webp';
import productImage4 from '../images/a4.webp';
import productImage5 from '../images/a5.webp';
import productImage8 from '../images/a8.webp';
import productImage9 from '../images/a11.webp';
import productImage10 from '../images/a22.webp';
import productImage11 from '../images/bkam.webp';
import productImage12 from '../images/a23.webp';
import productImage13 from '../images/a24.webp';
import productImage14 from '../images/a25.webp';
import productImage15 from '../images/a26.webp';
import productImage16 from '../images/a27.webp';
import productImage17 from '../images/a28.webp';
import productImage18 from '../images/a29.webp';
import productImage19 from '../images/a30.webp';
import productImage20 from '../images/a31.webp';
import productImage21 from '../images/a32.webp';

const images = [
  productImage1,
  productImage2,
  productImage3,
  productImage4,
  productImage5,
  productImage8,
  productImage9,
  productImage10,
  productImage11,
  productImage12,
  productImage13,
  productImage14,
  productImage15,
  productImage16,
  productImage17,
  productImage18,
  productImage19,
  productImage20,
  productImage21,
];

const Portfolio = () => {
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-4 py-20 md:px-6" id="portfolio">
      <div className="mb-10 text-center" data-aos="fade-up">
        <p className="text-sm font-semibold uppercase tracking-[0.28em] text-slate-500">
          Atmosphere
        </p>
        <h2 className="mt-4 font-cyclin text-4xl font-bold text-slate-950 md:text-5xl">
          A closer look at the space
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-8 text-slate-700">
          Browse the salon, treatment rooms and the atmosphere clients
          experience when they visit Amonthanat Massage.
        </p>
      </div>

      <div data-aos="fade-up" data-aos-delay="100">
        {isMobile ? (
          <div className="overflow-hidden rounded-[2rem] border border-white/60 bg-white/80 p-4 shadow-xl shadow-slate-900/10 backdrop-blur">
            <Carousel
              showArrows
              showThumbs={false}
              infiniteLoop
              useKeyboardArrows
              autoPlay
              interval={3200}
              stopOnHover
              swipeable
              dynamicHeight
              showStatus={false}
              showIndicators
            >
              {images.map((image, index) => (
                <div key={index} className="overflow-hidden rounded-[1.5rem]">
                  <img
                    src={image}
                    alt={`Amonthanat Massage ${index + 1}`}
                    onClick={() => setFullscreenImage(image)}
                    className="h-[360px] w-full cursor-pointer rounded-[1.5rem] object-cover"
                  />
                </div>
              ))}
            </Carousel>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {images.map((image, index) => (
              <button
                key={index}
                type="button"
                onClick={() => setFullscreenImage(image)}
                className="overflow-hidden rounded-[1.75rem] border border-white/60 bg-white/80 shadow-xl shadow-slate-900/10 transition hover:-translate-y-1 hover:shadow-2xl"
              >
                <img
                  src={image}
                  alt={`Amonthanat Massage ${index + 1}`}
                  className="h-[360px] w-full object-cover"
                />
              </button>
            ))}
          </div>
        )}
      </div>

      {fullscreenImage && (
        <div className="fullscreen-container" onClick={() => setFullscreenImage(null)}>
          <img
            src={fullscreenImage}
            alt="Fullscreen view"
            className="fullscreen-image"
          />
        </div>
      )}
    </section>
  );
};

export default Portfolio;
